import React, { useState, useEffect, Suspense } from "react";
import dynamic from "next/dynamic";
import ChartSkeleton from "@/src/components/companies/ChartSkeleton";
//import SnowFlakeChart from "../StockScreener/SnowFlake";
 //import { SnowFlakeChart } from "../StockScreener/SnowFlake";
// Dynamically import the SnowFlakeChart only when needed

const SnowFlakeChart = dynamic(() => import("../StockScreener/SnowFlake"), {
  loading: () => <ChartSkeleton />,
});

const CompanyOverview = ({ company }) => {
  const [isFullDescriptionShown, setIsFullDescriptionShown] = useState(false);
  const description = company?.description;

  const toggleDescription = () => {
    setIsFullDescriptionShown(!isFullDescriptionShown);
  };

  const { name, ceo, address, sector, industry, city, state, country } =
    company || {};
  const ticker = company?.tickers[0];

  return (
    <section id="overview" className="p-5 bg-white shadow-md rounded-lg border">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-lg md:text-xl font-bold mb-3">
            Overview for {name}
          </p>
          <p className="mb-2 font-light mt-5">
            <span className="font-bold">Industry:</span> {industry}
          </p>
          {sector ? (
            <p className="mb-2 font-light">
              <span className="font-bold">Sector:</span> {sector}
            </p>
          ) : (
            <p className="mb-2">
              <span className="font-bold">Sector:</span> Not available
            </p>
          )}
          <p className="mb-2 font-light">
            <span className="font-bold">Description:</span>
            {description?.length > 160 && !isFullDescriptionShown ? (
              <>
                {description.substring(0, 160)}...
                <button
                  onClick={toggleDescription}
                  className="text-blue-600 ml-1"
                >
                  Read More
                </button>
              </>
            ) : (
              <>
                {description || "Not available"}
                {description?.length > 160 && (
                  <button
                    onClick={toggleDescription}
                    className="text-blue-600 ml-1"
                  >
                    Show Less
                  </button>
                )}
              </>
            )}
          </p>
          {ceo ? (
            <p className="mb-2 font-light">
              <span className="font-bold">CEO:</span> {ceo}
            </p>
          ) : (
            <p className="mb-2">
              <span className="font-bold">CEO:</span> Not available
            </p>
          )}
          {address ? (
            <p className="mb-2 font-light">
              <span className="font-bold">Address:</span> {address}, {city},{" "}
              {state}, {country}
            </p>
          ) : (
            <p className="mb-2">
              <span className="font-bold">Address:</span> Not available
            </p>
          )}
        </div>
        <SnowFlakeChart ticker={ticker} />
      </div>
    </section>
  );
};

export default CompanyOverview;
